import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { dispatch } from "../store";

const appCurrency = localStorage.getItem("app-currency") || "USD";

const initialState = {
  isLoading: false,
  error: null,
  payingUserId: null,

  filters: {
    uiType: "TOPUP", // MONCASH | TOPUP | PINLESS | REMESAS
    uiCurrency: "USD",
    apiType: "topup", // topup|pinless|remesas
    startDate: "",
    endDate: "",
    currency: "USD",
  },

  commissions: {
    type: null,
    start_date: null,
    end_date: null,
    users: [],
  },
};

const slice = createSlice({
  name: "commission",
  initialState,
  reducers: {
    startLoading(state, action) {
      state.isLoading = true;
      state.error = null;

      if (action?.payload) {
        state.filters = { ...state.filters, ...action.payload };
      }
    },

    startPaying(state, action) {
      state.error = null;
      state.payingUserId = action.payload?.userId ?? null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.payingUserId = null;
      state.error = action.payload;

      state.commissions = { ...state.commissions };
    },

    getSummarySuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.commissions = action.payload;
    },

    paySuccess(state, action) {
      state.payingUserId = null;
      state.error = null;

      const { user_id, payment_id, payment_at } = action.payload;

      state.commissions.users = state.commissions.users.map((u) =>
        u.user_id === user_id
          ? {
              ...u,
              is_paid: true,
              payment_id: payment_id ?? u.payment_id,
              payment_at: payment_at ?? u.payment_at,
            }
          : u
      );
    },

    clearError(state) {
      state.error = null;
    },
  },
});

export default slice.reducer;
export const { clearError } = slice.actions;

// -------------------- thunks --------------------

export function getCommissions(payload) {
  return async () => {
    dispatch(slice.actions.startLoading(payload));

    try {
      const params = new URLSearchParams({
        type: payload.apiType,
        start_date: payload.startDate,
        end_date: payload.endDate,
        currency: payload.currency,
      });

      const res = await axios.get(
        `/api/v1/dashboard/commissions-summary?${params.toString()}`
      );

      dispatch(slice.actions.getSummarySuccess(res.data));
    } catch (error) {
      const data = error?.response?.data || { error: "Something went wrong." };
      dispatch(slice.actions.hasError(data));
    }
  };
}

export function payCommission(payload) {
  return async () => {
    dispatch(slice.actions.startPaying({ userId: payload.userId }));

    try {
      const response = await axios.post(`/api/v1/dashboard/commission-pay`, {
        user_id: payload.userId,
        type: payload.apiType,
        start_date: payload.startDate,
        end_date: payload.endDate,
        currency: payload.currency,
      });

      dispatch(
        slice.actions.paySuccess({
          user_id: response.data.user_id || payload.userId,
          payment_id: response.data.payment_id || null,
          payment_at: response.data.payment_at || null,
        })
      );

      return { ok: true, data: response.data };
    } catch (error) {
      const data = error?.response?.data || { error: "Payment failed." };
      dispatch(slice.actions.hasError(data));
      return { ok: false, error: data };
    }
  };
}
